/**
 * Recommendation Detail Page Route
 *
 * Displays detailed information about a specific recommendation
 * using the RecommendationDetailScreen component.
 *
 * Route: /recommendations/:recommendationId
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { RecommendationDetailScreen } from "@/components/recommendation-detail";
import { GlobalErrorFallback } from "@/components/error";

export const Route = createFileRoute("/recommendations/$recommendationId")({
  component: RecommendationDetailPage,
  errorComponent: GlobalErrorFallback,
});

function RecommendationDetailPage() {
  const { recommendationId } = Route.useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    // Navigate back to recommendations page
    navigate({ to: "/recommendations" });
  };

  return (
    <RecommendationDetailScreen
      recommendationId={recommendationId}
      onBack={handleBack}
    />
  );
}
